import { ReactNode } from 'react';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { COMPANY } from '@/config/company';

interface LegalPageProps {
  title: string;
  intro: string;
  sections: { heading: string; body: ReactNode }[];
}

export default function LegalPage({ title, intro, sections }: LegalPageProps) {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-3xl">
          <h1 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">{title}</h1>
          <p className="text-muted-foreground text-lg mb-10">{intro}</p>

          <div className="space-y-8">
            {sections.map((s) => (
              <section key={s.heading}>
                <h2 className="font-display text-xl font-bold text-foreground mb-3">{s.heading}</h2>
                <div className="text-muted-foreground leading-relaxed space-y-3">{s.body}</div>
              </section>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-border text-sm text-muted-foreground">
            <p className="font-medium text-foreground mb-1">Questions about this policy?</p>
            <p>
              {COMPANY.legalName}, {COMPANY.addressLine1}, {COMPANY.addressLine2} ·{' '}
              <a href={`mailto:${COMPANY.email}`} className="hover:text-accent transition-colors">{COMPANY.email}</a> ·{' '}
              <a href={COMPANY.phoneHref} className="hover:text-accent transition-colors">{COMPANY.phone}</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
